// extracted by mini-css-extract-plugin
export default {"reactions":"Icons_reactions__YFHAG"};